import type en from '../en/admin'
import type { Translation } from '../types'

/** Platform administration */
const admin: Translation<typeof en> = {
  "admin.module.webhooks.label": "Webhooks",
  "admin.module.webhooks.desc": "Ausgehende HTTP-Webhooks bei Ereignissen",
  "admin.module.branding.label": "Branding",
  "admin.module.branding.desc": "Eigenes Logo, eigene Farben, White Label",
  "admin.module.apiKeys.label": "API-Schlüssel",
  "admin.module.apiKeys.desc": "API-Zugriff für Skripte und andere Systeme",
  "admin.module.templates.label": "Vorlagen",
  "admin.module.templates.desc": "Vorlagen und Assistent für die Netzwerkkonfiguration",
  "admin.module.customDomain.label": "Eigene Domain",
  "admin.module.customDomain.desc": "Anmeldung unter der eigenen Adresse des Unternehmens",
  "admin.module.customEmail.label": "Eigener Mailserver",
  "admin.module.customEmail.desc": "SMTP pro Unternehmen",
  "admin.module.sso.label": "Single Sign-on",
  "admin.module.sso.desc": "Anmeldung über den Identitätsanbieter des Unternehmens (OpenID Connect)",
  "admin.module.ownWhatsapp.label": "Eigenes WhatsApp",
  "admin.module.ownWhatsapp.desc": "Das eigene Meta- oder Twilio-Konto des Unternehmens",
  "admin.module.ownRcs.label": "Eigenes RCS",
  "admin.module.ownRcs.desc": "Der eigene RCS-Absender des Unternehmens (Google oder Twilio)",
  "admin.module.linkedWhatsapp.label": "Verknüpfte WhatsApp-Nummer",
  "admin.module.linkedWhatsapp.desc": "Das Unternehmen verknüpft seine eigene WhatsApp-Nummer mit dem Server (open-wa)",
  "admin.module.unifi.label": "UniFi",
  "admin.module.unifi.desc": "UniFi-Controller und Site Manager",
  "admin.module.teltonika.label": "Teltonika",
  "admin.module.teltonika.desc": "RutOS-Geräte und RMS",
  "admin.module.peplink.label": "Peplink",
  "admin.module.peplink.desc": "Peplink-Geräte und InControl2",
  "admin.module.mikrotik.label": "MikroTik",
  "admin.module.mikrotik.desc": "RouterOS-Router, Access Points und Funkstrecken",
  "admin.module.velanox.label": "Velanox One Speed",
  "admin.module.velanox.desc": "Velanox-Boxen und Endpunkte",
  "admin.overview.title": "Plattformübersicht",
  "admin.overview.subtitle": "Dashboard der Plattformverwaltung",
  "admin.overview.companies": "Unternehmen",
  "admin.overview.users": "Benutzer",
  "admin.overview.sites": "Standorte",
  "admin.overview.pendingJobs": "Wartende Aufträge",
  "admin.overview.revocations": "Zertifikatswiderrufe, die wiederholt werden",
  "admin.overview.revocationsText": "Diese VPN-Zertifikate konnten noch nicht widerrufen werden und funktionieren daher noch. Jedes wird erneut versucht (höchstens eine Stunde Abstand), bis es gelingt.",
  "admin.overview.siteCert": "Standortzertifikat",
  "admin.overview.userCert": "Benutzerzertifikat",
  "admin.overview.tries": { one: "{count} Versuch · nächster Versuch {when}", other: "{count} Versuche · nächster Versuch {when}" },
  "admin.overview.byStatus": "Unternehmen nach Status",
  "admin.overview.jobs": "Auftragswarteschlange",
  "admin.overview.all": "Alle",
  "admin.overview.refreshJobs": "Aufträge aktualisieren",
  "admin.overview.noJobs": "Keine Aufträge",
  "admin.overview.audit": "Aktuelles Prüfprotokoll",
  "admin.overview.noAudit": "Keine Einträge im Prüfprotokoll",
  "admin.overview.system": "System",
  "admin.vpn.title": "VPN-Verwaltung",
  "admin.vpn.subtitle": "OpenVPN-Server, die Netze und Konten jedes Unternehmens",
  "admin.vpn.refresh": "Aktualisieren",
  "admin.vpn.server": "Server",
  "admin.vpn.running": "Läuft",
  "admin.vpn.stopped": "Gestoppt",
  "admin.vpn.since": "Seit {when}",
  "admin.vpn.connectedNow": "Jetzt verbunden",
  "admin.vpn.ofActive": { one: "von {count} aktiven Konto", other: "von {count} aktiven Konten" },
  "admin.vpn.totalAccounts": "Konten insgesamt",
  "admin.vpn.acrossCompanies": { one: "in {count} Unternehmen", other: "in {count} Unternehmen" },
  "admin.vpn.networks": "Netze",
  "admin.vpn.isolated": "getrennte /24-Subnetze",
  "admin.vpn.currentlyConnected": "Jetzt verbunden ({count})",
  "admin.vpn.commonName": "Common Name",
  "admin.vpn.realIp": "Echte IP",
  "admin.vpn.sinceCol": "Seit",
  "admin.vpn.usersSites": "Benutzer: {users} · Standorte: {sites}",
  "admin.vpn.connectedOf": { one: "{connected} verbunden / {count} Konto", other: "{connected} verbunden / {count} Konten" },
  "admin.vpn.noAccounts": "Noch keine VPN-Konten",
  "admin.vpn.name": "Name",
  "admin.vpn.logs": "OpenVPN-Protokolle",
  "admin.vpn.logLines": "Protokollzeilen",
  "admin.vpn.lines": { one: "{count} Zeile", other: "{count} Zeilen" },
  "admin.vpn.refreshLogs": "Protokolle aktualisieren",
  "admin.vpn.hide": "Ausblenden",
  "admin.vpn.showLogs": "Protokolle anzeigen",
  "admin.vpn.loadHint": "Wählen Sie „Protokolle anzeigen“, um sie zu laden",
  "admin.plans.toggleFailed": "Nicht geändert",
  "admin.plans.deleted": "Plan gelöscht",
  "admin.plans.deleteFailed": "Der Plan kann nicht gelöscht werden – er hat möglicherweise aktive Lizenzen",
  "admin.plans.title": "Lizenzpläne",
  "admin.plans.subtitle": "Wiederverwendbare Lizenztypen und die Module, die sie freischalten",
  "admin.plans.new": "Neuer Plan",
  "admin.plans.deleteConfirm": "Plan „{name}“ löschen? Unternehmen, die ihn nutzen, behalten ihre aktuelle Lizenz.",
  "admin.plans.empty": "Noch keine Lizenzpläne – erstellen Sie einen, um ihn Unternehmen zuzuweisen",
  "admin.plans.createTitle": "Lizenzplan erstellen",
  "admin.plans.created": "Plan erstellt",
  "admin.plans.editTitle": "Bearbeiten: {name}",
  "admin.plans.updated": "Plan aktualisiert",
  "admin.plans.public": "Öffentlich",
  "admin.plans.activeCount": { one: "{count} aktiv", other: "{count} aktiv" },
  "admin.plans.editNamed": "{name} bearbeiten",
  "admin.plans.deleteNamed": "{name} löschen",
  "admin.plans.sites": "Standorte",
  "admin.plans.users": "Benutzer",
  "admin.plans.duration": "Laufzeit",
  "admin.plans.daysShort": "{count} T",
  "admin.plans.modules": "Module",
  "admin.plans.nameRequired": "Ein Name ist erforderlich",
  "admin.plans.saveFailed": "Der Plan konnte nicht gespeichert werden",
  "admin.plans.name": "Name des Plans *",
  "admin.plans.namePlaceholder": "z. B. Professional",
  "admin.plans.description": "Beschreibung",
  "admin.plans.descriptionPlaceholder": "Optionale Beschreibung",
  "admin.plans.limits": "Grenzen",
  "admin.plans.limitsHint": "(leer lassen für unbegrenzt)",
  "admin.plans.maxSites": "Höchstzahl an Standorten",
  "admin.plans.maxUsers": "Höchstzahl an Benutzern",
  "admin.plans.durationDays": "Laufzeit (Tage)",
  "admin.plans.included": "Enthaltene Module",
  "admin.plans.selfSignup": "Für die Selbstregistrierung verfügbar",
  "admin.plans.selfSignupHint": "Diesen Plan auf der Registrierungsseite zeigen",
  "admin.plans.save": "Plan speichern",
  "admin.admins.removed": "Globaler Administrator entfernt",
  "admin.admins.removeFailed": "Entfernen fehlgeschlagen",
  "admin.admins.reset2faDone": "Zwei-Faktor-Anmeldung zurückgesetzt",
  "admin.admins.reset2faText": "Die Person wird überall abgemeldet und richtet sie bei der nächsten Anmeldung neu ein.",
  "admin.admins.resetFailed": "Zurücksetzen fehlgeschlagen",
  "admin.admins.title": "Globale Administratoren",
  "admin.admins.subtitle": "Personen mit globalen Administratorrechten: Plattformverwaltung für jedes Unternehmen",
  "admin.admins.add": "Globalen Administrator hinzufügen",
  "admin.admins.warning": "Globale Administratoren haben vollen Zugriff auf alle Unternehmen, Einstellungen und Daten der Plattform. Vergeben Sie das nur an vertrauenswürdige Mitarbeitende.",
  "admin.admins.name": "Name",
  "admin.admins.email": "E-Mail",
  "admin.admins.role": "Rolle",
  "admin.admins.lastLogin": "Letzte Anmeldung",
  "admin.admins.created": "Erstellt",
  "admin.admins.empty": "Keine globalen Administratoren gefunden",
  "admin.admins.you": "(Sie)",
  "admin.admins.owner": "Eigentümer",
  "admin.admins.superAdmin": "Super-Administrator",
  "admin.admins.admin": "Administrator",
  "admin.admins.invited": "Eingeladen",
  "admin.admins.never": "Nie",
  "admin.admins.edit": "Bearbeiten",
  "admin.admins.editNamed": "{name} bearbeiten",
  "admin.admins.reset2fa": "Zwei-Faktor-Anmeldung zurücksetzen",
  "admin.admins.reset2faFor": "Zwei-Faktor-Anmeldung für {name} zurücksetzen",
  "admin.admins.reset2faConfirm": "Zwei-Faktor-Anmeldung für „{name}“ zurücksetzen? Die Person wird überall abgemeldet und richtet sie bei der nächsten Anmeldung neu ein.",
  "admin.admins.ownerFixed": "Der Eigentümer der Plattform kann nicht entfernt werden",
  "admin.admins.notSelf": "Sie können Ihre eigenen Rechte nicht entfernen",
  "admin.admins.remove": "Entfernen",
  "admin.admins.removeNamed": "{name} als globalen Administrator entfernen",
  "admin.admins.removeConfirm": "„{name}“ ({email}) als globalen Administrator entfernen? Ein Konto, das zu Unternehmen gehört, behält diese; eines ohne wird gelöscht.",
  "admin.admins.ownHint": "Ihren eigenen Namen, Ihr Passwort und Ihre Zwei-Faktor-Anmeldung finden Sie unter",
  "admin.admins.invitationSent": "Einladung gesendet",
  "admin.admins.invitationText": "{email} legt über die E-Mail ein Passwort fest und danach die Zwei-Faktor-Anmeldung.",
  "admin.admins.added": "Globaler Administrator hinzugefügt",
  "admin.admins.addedText": "Dieses Konto hat jetzt globale Administratorrechte.",
  "admin.admins.editTitle": "Bearbeiten: {name}",
  "admin.admins.updated": "Administrator aktualisiert",
  "admin.admins.required": "Name und E-Mail-Adresse sind erforderlich",
  "admin.admins.saveFailed": "Speichern fehlgeschlagen",
  "admin.admins.fullName": "Vollständiger Name *",
  "admin.admins.emailAddress": "E-Mail-Adresse *",
  "admin.admins.emailAddressPlain": "E-Mail-Adresse",
  "admin.admins.emailHint": "Ein bestehendes Konto erhält die Rechte. Eine neue Adresse erhält eine E-Mail zum Festlegen eines Passworts.",
  "admin.admins.emailFixed": "Die E-Mail-Adresse kann nicht geändert werden",
  "admin.admins.superAdminHint": "Kann andere globale Administratoren und plattformkritische Einstellungen verwalten",
  "admin.admins.saveChanges": "Änderungen speichern",
  "admin.admins.sendInvitation": "Einladung senden",
  "admin.settings.provider": "Anbieter",
  "admin.settings.serverSettings": "Servereinstellungen verwenden (.env)",
  "admin.settings.off": "Aus",
  "admin.settings.waHint": "Sobald hier Meta oder Twilio gewählt ist, zählen nur die Werte auf dieser Seite: Aus den Einstellungen des Servers wird nichts übernommen. Gespeicherte Änderungen gelten sofort, ohne Neustart. Tokens werden verschlüsselt gespeichert und nie wieder angezeigt. Unternehmen mit dem Lizenzmodul Eigenes WhatsApp können stattdessen ihre eigene Verbindung nutzen (Unternehmenseinstellungen → WhatsApp).",
  "admin.settings.changedProvider": "Sie haben den Anbieter geändert: Speichern Sie die Einstellungen, um ihn zu verwenden.",
  "admin.settings.rcsHint": "RCS-Nachrichten kommen in der Nachrichten-App des Telefons an, unter Ihrem bestätigten Unternehmensnamen. Sobald hier Google oder Twilio gewählt ist, zählen nur die Werte auf dieser Seite. Gespeicherte Änderungen gelten sofort. Schlüssel und Tokens werden verschlüsselt gespeichert und nie wieder angezeigt. Unternehmen mit dem Lizenzmodul Eigenes RCS können stattdessen ihren eigenen Absender nutzen (Unternehmenseinstellungen → RCS).",
  "admin.settings.templatesChecked": "Vorlagen geprüft",
  "admin.settings.syncFailed": "Synchronisierung fehlgeschlagen",
  "admin.settings.tryAgain": "Versuchen Sie es gleich noch einmal.",
  "admin.settings.templatesOff": "Wenn WhatsApp über Twilio läuft (oben oder in den Einstellungen des Servers gewählt), erstellt die Plattform die Vorlagen selbst und Unternehmen können ihre Texte ändern. Bei Meta werden die in den Einstellungen genannten Vorlagen verwendet.",
  "admin.settings.templatesIntro": "WhatsApp genehmigt jeden Text, bevor er verwendet werden kann. Neue Texte werden alle 30 Minuten eingereicht und Entscheidungen abgerufen; bis der eigene Text eines Unternehmens genehmigt ist, wird der Standardtext gesendet.",
  "admin.settings.templatesInUse": { one: "{count} Vorlage in Verwendung. WhatsApp erlaubt {unverified} pro Unternehmenskonto oder {verified}, sobald das Unternehmen bei Meta verifiziert ist. Der eigene WhatsApp-Text jedes Unternehmens ist eine eigene Vorlage.", other: "{count} Vorlagen in Verwendung. WhatsApp erlaubt {unverified} pro Unternehmenskonto oder {verified}, sobald das Unternehmen bei Meta verifiziert ist. Der eigene WhatsApp-Text jedes Unternehmens ist eine eigene Vorlage." },
  "admin.settings.nearLimit": "Nahe am Limit eines nicht verifizierten Unternehmenskontos ({limit}). Lassen Sie das Unternehmen bei Meta verifizieren, sonst können neue Texte nach Erreichen des Limits nicht mehr genehmigt werden.",
  "admin.settings.message": "Nachricht",
  "admin.settings.text": "Text",
  "admin.settings.usedBy": "Verwendet von",
  "admin.settings.authMessage": "Die eigene Bestätigungscode-Nachricht von WhatsApp",
  "admin.settings.usedBy.default": "Standard",
  "admin.settings.usedBy.previousDefault": "Bisheriger Standard, bis der neue Text genehmigt ist",
  "admin.settings.notUsed": "Nicht mehr verwendet",
  "admin.settings.wa.approved": "genehmigt",
  "admin.settings.wa.rejected": "abgelehnt",
  "admin.settings.wa.failed": "nicht eingereicht",
  "admin.settings.wa.paused": "pausiert",
  "admin.settings.wa.disabled": "deaktiviert",
  "admin.settings.wa.pending": "wartet",
  "admin.settings.noTemplates": "Noch keine: Die erste Synchronisierung erstellt sie.",
  "admin.settings.syncNow": "Jetzt synchronisieren",
  "admin.settings.testSent": "Test-E-Mail gesendet",
  "admin.settings.checkInbox": "Sehen Sie in {to} nach",
  "admin.settings.smtpFailed": "SMTP-Test fehlgeschlagen",
  "admin.settings.save": "Einstellungen speichern",
  "admin.settings.title": "Plattformeinstellungen",
  "admin.settings.subtitle": "Allgemeines Verhalten, E-Mail, WhatsApp, RCS und VPN",
  "admin.settings.tab": "Einstellungen",
  "admin.settings.edgeTab": "Edge-Proxy (Caddy + HAProxy) →",
  "admin.settings.loading": "Wird geladen",
  "admin.settings.behaviour": "Verhalten der Plattform",
  "admin.settings.licensing": "Lizenzierung an",
  "admin.settings.licensingHint": "Lizenzgrenzen durchsetzen. Ausschalten für unbegrenzten Zugriff.",
  "admin.settings.maintenance": "Wartungsmodus",
  "admin.settings.maintenanceHint": "Verhindert die Anmeldung von Unternehmensbenutzern. Globale Administratoren behalten den Zugriff.",
  "admin.settings.selfRegistration": "Selbstregistrierung erlauben",
  "admin.settings.selfRegistrationHint": "Unternehmen können sich ohne Einladung eines globalen Administrators registrieren.",
  "admin.settings.adminIdle": "Globale Administratoren: Abmelden nach einer Zeit ohne Aktivität, höchstens",
  "admin.settings.adminIdleHint": "Standardmäßig 1 Stunde; jeder Administrator kann unter Mein Profil eine kürzere Zeit wählen.",
  "admin.settings.idleOff": "Administratoren dürfen das Abmelden nach Inaktivität ausschalten",
  "admin.settings.idleOffHint": "Für ihr eigenes Konto.",
  "admin.settings.idleOffWarning": "Damit können globale Administratoren einen der Kontoschutzmechanismen der Plattform ausschalten: Eine auf einem unbeaufsichtigten Computer offen gelassene Administratorsitzung bleibt dann angemeldet, bis sie ihre maximale Dauer erreicht.",
  "admin.settings.idleOffQuestion": "Erlauben?",
  "admin.settings.defaultLicense": "Standard-Lizenztyp",
  "admin.settings.licenseType.TRIAL": "Testversion",
  "admin.settings.licenseType.STANDARD": "Standard",
  "admin.settings.licenseType.UNLIMITED": "Unbegrenzt",
  "admin.settings.licenseType.CUSTOM": "Individuell",
  "admin.settings.trialDays": "Standardmäßige Testtage",
  "admin.settings.email": "E-Mail / SMTP",
  "admin.settings.emailIntro": "Standardwerte für die ganze Plattform. Unternehmen können in ihren Unternehmenseinstellungen ihr eigenes SMTP nutzen. Passwörter werden vor dem Speichern mit AES-256 verschlüsselt.",
  "admin.settings.smtpHost": "SMTP-Host",
  "admin.settings.smtpPort": "SMTP-Port",
  "admin.settings.username": "Benutzername",
  "admin.settings.password": "Passwort",
  "admin.settings.saved": "✓ gespeichert",
  "admin.settings.keepPassword": "(leer lassen, um das aktuelle zu behalten)",
  "admin.settings.enterPassword": "SMTP-Passwort",
  "admin.settings.hidePassword": "Passwort verbergen",
  "admin.settings.showPassword": "Passwort anzeigen",
  "admin.settings.fromEmail": "Absenderadresse",
  "admin.settings.fromName": "Absendername",
  "admin.settings.sendTest": "Test-E-Mail senden",
  "admin.settings.testRecipient": "Empfänger des Tests",
  "admin.settings.testRecipientPlaceholder": "ihre@e-mail.de",
  "admin.settings.send": "Test senden",
  "admin.settings.waTemplates": "WhatsApp-Vorlagen",
  "admin.settings.vpn": "VPN / OpenVPN",
  "admin.settings.vpnIntro": "Steuert das VPN für neue Unternehmen. Jedes Unternehmen erhält ein eigenes /24-Subnetz.",
  "admin.settings.serverHost": "Hostname / IP des Servers",
  "admin.settings.usersBase": "Basis des Benutzernetzes",
  "admin.settings.sitesBase": "Basis des Standortnetzes",
  "admin.settings.usersExample": "Unternehmen 1 → 10.8.1.0/24 · Unternehmen 2 → 10.8.2.0/24 …",
  "admin.settings.sitesExample": "Unternehmen 1 → 10.9.1.0/24 · Unternehmen 2 → 10.9.2.0/24 …",
  "admin.licences.deleted": "Lizenz gelöscht",
  "admin.licences.deleteFailed": "Löschen fehlgeschlagen",
  "admin.licences.notified": "E-Mail an die Administratoren des Unternehmens gesendet",
  "admin.licences.notifyFailed": "Die E-Mail konnte nicht gesendet werden",
  "admin.licences.keyRevoked": "Schlüssel widerrufen",
  "admin.licences.revokeFailed": "Widerruf fehlgeschlagen",
  "admin.licences.unusedDeleted": "Unbenutzte Schlüssel gelöscht",
  "admin.licences.expiredDeleted": "Abgelaufene Lizenzen gelöscht",
  "admin.licences.bulkFailed": "Löschen fehlgeschlagen",
  "admin.licences.tab.used": "Aktiv",
  "admin.licences.tab.available": "Schlüssel",
  "admin.licences.tab.expired": "Abgelaufen",
  "admin.licences.title": "Lizenzübersicht",
  "admin.licences.subtitle": "Alle auf der Plattform ausgegebenen Lizenzen und Schlüssel",
  "admin.licences.generate": "Schlüssel erzeugen",
  "admin.licences.activeCount": "Aktive Lizenzen",
  "admin.licences.availableCount": "Verfügbare Schlüssel",
  "admin.licences.expiredCount": "Abgelaufene Lizenzen",
  "admin.licences.totalKeys": "Ausgegebene Schlüssel insgesamt",
  "admin.licences.company": "Unternehmen",
  "admin.licences.plan": "Plan",
  "admin.licences.started": "Beginn",
  "admin.licences.expires": "Läuft ab",
  "admin.licences.limits": "Grenzen",
  "admin.licences.noActive": "Keine aktiven Lizenzen",
  "admin.licences.daysLeft": { one: "noch {count} Tag", other: "noch {count} Tage" },
  "admin.licences.unlimited": "Unbegrenzt",
  "admin.licences.sites": { one: "{count} Standort", other: "{count} Standorte" },
  "admin.licences.sitesUnlimited": "∞ Standorte",
  "admin.licences.users": { one: "{count} Benutzer", other: "{count} Benutzer" },
  "admin.licences.usersUnlimited": "∞ Benutzer",
  "admin.licences.thisCompany": "dieses Unternehmen",
  "admin.licences.deleteFor": "Lizenz von {name} löschen",
  "admin.licences.deleteConfirm": "Die Lizenz von „{name}“ löschen?",
  "admin.licences.deleteUnusedConfirm": { one: "Den unbenutzten Schlüssel löschen?", other: "Alle {count} unbenutzten Schlüssel löschen?" },
  "admin.licences.deleteUnused": "Alle unbenutzten löschen",
  "admin.licences.available": "Verfügbar ({count})",
  "admin.licences.key": "Schlüssel",
  "admin.licences.restriction": "Einschränkung",
  "admin.licences.created": "Erstellt",
  "admin.licences.redeemed": "Eingelöst ({count})",
  "admin.licences.usedBy": "Verwendet von",
  "admin.licences.redeemedAt": "Eingelöst",
  "admin.licences.noKeys": "Noch keine Lizenzschlüssel – erzeugen Sie oben welche",
  "admin.licences.deleteExpiredConfirm": { one: "Die abgelaufene Lizenz löschen?", other: "Alle {count} abgelaufenen Lizenzen löschen?" },
  "admin.licences.deleteExpired": "Alle abgelaufenen löschen",
  "admin.licences.expiredOn": "Abgelaufen",
  "admin.licences.durationWas": "Laufzeit war",
  "admin.licences.noExpired": "Keine abgelaufenen Lizenzen",
  "admin.licences.days": { one: "{count} Tag", other: "{count} Tage" },
  "admin.licences.notifyHint": "Die Administratoren des Unternehmens per E-Mail über den Ablauf informieren",
  "admin.licences.notify": "Benachrichtigen",
  "admin.licences.deleteExpiredFor": "Abgelaufene Lizenz von {name} löschen",
  "admin.licences.deleteExpiredOne": "Die abgelaufene Lizenz von „{name}“ löschen?",
  "admin.licences.copyKey": "Den vollständigen Schlüssel kopieren",
  "admin.licences.anyPlan": "Beliebig",
  "admin.licences.companyOnly": "🏢 Nur ein Unternehmen",
  "admin.licences.noRestriction": "🌐 Unbegrenzt",
  "admin.licences.never": "Nie",
  "admin.licences.revokeKey": "Schlüssel widerrufen",
  "admin.licences.revokeConfirm": "Diesen Schlüssel widerrufen?",
  "admin.licences.generated": { one: "{count} Schlüssel erzeugt", other: "{count} Schlüssel erzeugt" },
  "admin.licences.generateFailed": "Erzeugung fehlgeschlagen",
  "admin.licences.generateTitle": { one: "Lizenzschlüssel erzeugen", other: "Lizenzschlüssel erzeugen" },
  "admin.licences.sendKeys": "Kopieren Sie diese Schlüssel und senden Sie sie an Ihre Kunden. Sie können sie bei der Registrierung oder in den Kontoeinstellungen einlösen.",
  "admin.licences.copy": "Kopieren",
  "admin.licences.allCopied": "Alle Schlüssel kopiert",
  "admin.licences.copyAll": "Alle kopieren",
  "admin.licences.done": "Fertig",
  "admin.licences.licencePlan": "Lizenzplan",
  "admin.licences.anyPlanOption": "Jeder Plan (keine Einschränkung)",
  "admin.licences.restrict.unlimited": "🌐 Unbegrenzt",
  "admin.licences.restrict.email": "📧 E-Mail",
  "admin.licences.restrict.company": "🏢 Unternehmen",
  "admin.licences.limitEmail": "Auf E-Mail-Adresse beschränken",
  "admin.licences.limitCompany": "Auf Unternehmen beschränken",
  "admin.licences.chooseCompany": "Wählen Sie ein Unternehmen…",
  "admin.licences.count": "Anzahl der Schlüssel",
  "admin.licences.keyExpires": "Schlüssel läuft ab",
  "admin.licences.optional": "(optional)",
  "admin.licences.notes": "Notizen",
  "admin.licences.notesPlaceholder": "Interne Notiz zu diesem Schlüsselsatz",
  "admin.licences.generateCount": { one: "Schlüssel erzeugen", other: "{count} Schlüssel erzeugen" },
  "admin.edge.resolves": "{domain} wird korrekt aufgelöst",
  "admin.edge.dnsNotHere": "Das DNS zeigt noch nicht hierher",
  "admin.edge.resolvesTo": "Wird aufgelöst zu {ips}",
  "admin.edge.noARecord": "Kein A-Eintrag gefunden",
  "admin.edge.proven": "Inhaberschaft nachgewiesen",
  "admin.edge.servesNow": "Die Domain zeigt jetzt das Dashboard.",
  "admin.edge.notProvenYet": "Noch nicht nachgewiesen",
  "admin.edge.markedProven": "Als nachgewiesen markiert",
  "admin.edge.ownershipReset": "Inhaberschaft zurückgesetzt",
  "admin.edge.resetText": "Die Domain zeigt die Einrichtungsseite, bis der neue TXT-Eintrag gefunden wird.",
  "admin.edge.failed": "Fehlgeschlagen",
  "admin.edge.requestFailed": "Die Anfrage ist fehlgeschlagen",
  "admin.edge.removed": "Domain entfernt",
  "admin.edge.caddyApplied": "Caddy-Konfiguration angewendet",
  "admin.edge.caddyRejected": "Caddy hat die Konfiguration abgelehnt",
  "admin.edge.title": "Edge-Proxy",
  "admin.edge.subtitle": "HAProxy vor :80/:443 · Caddy beendet TLS und stellt Zertifikate bei Bedarf aus · OpenVPN je Unternehmen über UDP",
  "admin.edge.addDomain": "Domain hinzufügen",
  "admin.edge.connections": { one: "{count} Verbindung", other: "{count} Verbindungen" },
  "admin.edge.notReachable": "Nicht erreichbar",
  "admin.edge.onDemandOn": "TLS bei Bedarf aktiv",
  "admin.edge.onDemandOff": "TLS bei Bedarf NICHT eingerichtet",
  "admin.edge.edgeIp": "Edge-IP",
  "admin.edge.noEdgeIp": "Nicht gesetzt – Kunden kann nicht gesagt werden, wohin ihr DNS zeigen soll",
  "admin.edge.acme": "ACME: {email}",
  "admin.edge.noAcme": "Keine ACME-E-Mail-Adresse gesetzt",
  "admin.edge.caddyWarnBefore": "Caddy läuft, aber TLS bei Bedarf ist nicht mit dem Ask-Endpunkt verbunden. White-Label-Domains erhalten keine Zertifikate, bis Sie die Konfiguration übertragen – verwenden Sie ",
  "admin.edge.caddyWarnAfter": " unter Konfiguration.",
  "admin.edge.tab.domains": "Domains ({count})",
  "admin.edge.tab.vpn": "VPN-Instanzen",
  "admin.edge.tab.config": "Konfiguration",
  "admin.edge.domain": "Domain",
  "admin.edge.type": "Typ",
  "admin.edge.company": "Unternehmen",
  "admin.edge.dns": "DNS",
  "admin.edge.ownership": "Inhaberschaft",
  "admin.edge.certificate": "Zertifikat",
  "admin.edge.noDomains": "Noch keine Domains",
  "admin.edge.typeName.WHITELABEL": "White-Label",
  "admin.edge.typeName.PLATFORM": "Plattform",
  "admin.edge.typeName.APP": "Andere App",
  "admin.edge.typeName.REDIRECT": "Weiterleitung",
  "admin.edge.typeName.VPN": "VPN",
  "admin.edge.typeDesc.WHITELABEL": "Die eigene Dashboard-Domain eines Kunden",
  "admin.edge.typeDesc.PLATFORM": "Ihr eigener Hostname für das Dashboard",
  "admin.edge.typeDesc.APP": "Eine andere Web-App auf diesem Server",
  "admin.edge.typeDesc.REDIRECT": "Leitet diesen Namen an einen anderen weiter",
  "admin.edge.dnsResolves": "aufgelöst",
  "admin.edge.awaitingDns": "wartet auf DNS",
  "admin.edge.provenBadge": "nachgewiesen",
  "admin.edge.provenBy": "durch {name}",
  "admin.edge.anAdmin": "einen Administrator",
  "admin.edge.byDns": "per DNS-Eintrag",
  "admin.edge.notProven": "nicht nachgewiesen",
  "admin.edge.certFailed": "fehlgeschlagen",
  "admin.edge.certOnFirst": "bei der ersten Anfrage ausgestellt",
  "admin.edge.certAuto": "automatisch angefordert",
  "admin.edge.pendingDns": "wartet auf DNS",
  "admin.edge.recheck": "DNS erneut prüfen",
  "admin.edge.resetOwnership": "Inhaberschaft zurücksetzen",
  "admin.edge.resetConfirm": "Die Inhaberschaft von {domain} zurücksetzen? Sie zeigt die Seite „wird eingerichtet“, bis das Unternehmen den neuen TXT-Eintrag veröffentlicht.",
  "admin.edge.remove": "Entfernen",
  "admin.edge.removeWhitelabel": "{domain} entfernen? Die VPN-Konfigurationen fallen auf den Hostnamen der Plattform zurück.",
  "admin.edge.removeOther": "{domain} entfernen? Dieser Server antwortet dann nicht mehr dafür.",
  "admin.edge.txtRecord": "Inhaberschaftseintrag (TXT):",
  "admin.edge.copyRecord": "Den Eintragswert für {domain} kopieren",
  "admin.edge.releasedOn": "Freigegeben am {date}, sofern nicht nachgewiesen",
  "admin.edge.checkNow": "Jetzt prüfen",
  "admin.edge.overrideConfirm": "{domain} ohne TXT-Eintrag als nachgewiesen markieren? Sie zeigt dann sofort das Dashboard von {company}.",
  "admin.edge.theCompany": "dem Unternehmen",
  "admin.edge.markProven": "Als nachgewiesen markieren",
  "admin.edge.vpnIntroBefore": "Zwei OpenVPN-Server je Unternehmen (Benutzer und Standorte), jeder auf einem eigenen UDP-Port. Ein Neustart oder eine fehlerhafte Konfiguration betrifft nur dieses Unternehmen. White-Label-Unternehmen benötigen einen A-Eintrag ",
  "admin.edge.vpnIntroAfter": ", der auf die Edge-IP zeigt.",
  "admin.edge.theirDomain": "ihre-domain",
  "admin.edge.unit": "Unit",
  "admin.edge.udpPorts": "UDP-Ports",
  "admin.edge.connectTo": "Clients verbinden sich mit",
  "admin.edge.state": "Zustand",
  "admin.edge.noInstances": "Keine VPN-Instanzen eingerichtet",
  "admin.edge.whitelabelHost": "White-Label: {domain}",
  "admin.edge.usersPort": "Benutzer {port}",
  "admin.edge.sitesPort": "Standorte {port}",
  "admin.edge.repoint": "Wieder auf die aktuelle Domain ausrichten",
  "admin.edge.hostRefreshed": "Entfernter Host aktualisiert",
  "admin.edge.reprovision": "Erneut einrichten",
  "admin.edge.vpnRunning": "VPN-Server laufen",
  "admin.edge.queued": { one: "{count} Konto, das zuvor nicht erstellt werden konnte, ist in der Warteschlange", other: "{count} Konten, die zuvor nicht erstellt werden konnten, sind in der Warteschlange" },
  "admin.edge.vpnNotRunning": "VPN-Server laufen nicht",
  "admin.edge.provisionFailed": "Einrichtung fehlgeschlagen",
  "admin.edge.stop": "Stoppen",
  "admin.edge.stopConfirm": "Das VPN von {company} stoppen? Die Tunnel brechen ab.",
  "admin.edge.attention": "Erfordert Aufmerksamkeit",
  "admin.edge.healthy": "In Ordnung",
  "admin.edge.unreachable": "Nicht erreichbar",
  "admin.edge.caddyText": "Überträgt die erzeugte Konfiguration über die Admin-API. Plattform-Domains sind ausdrücklich aufgeführt; White-Label-Domains nutzen TLS bei Bedarf über den Ask-Endpunkt, daher braucht eine neue Domain kein Neuladen.",
  "admin.edge.applyCaddy": "Caddy-Konfiguration anwenden",
  "admin.edge.haproxyText1": "Vom Installationsprogramm eingerichtet und nur geändert, wenn sich der Edge selbst ändert. Die Konfiguration, die er haben sollte, steht unten: Kopieren Sie sie nach ",
  "admin.edge.haproxyText2": " auf dem Server, prüfen Sie sie mit ",
  "admin.edge.haproxyText3": ", verschieben Sie sie über ",
  "admin.edge.haproxyText4": " und führen Sie ",
  "admin.edge.haproxyText5": " aus. Das Dashboard schreibt sie nicht: Die API läuft ohne Root.",
  "admin.edge.generatedCfg": "Erzeugte haproxy.cfg",
  "admin.edge.copy": "Kopieren",
  "admin.edge.registered": "Domain registriert",
  "admin.edge.addFailed": "Die Domain konnte nicht hinzugefügt werden",
  "admin.edge.registeredTitle": "{domain} registriert",
  "admin.edge.currentlyResolves": "Wird derzeit aufgelöst zu: {ips}",
  "admin.edge.done": "Fertig",
  "admin.edge.domainLabel": "Domain *",
  "admin.edge.pointA": "Richten Sie einen A-Eintrag auf ",
  "admin.edge.certSoon": " Das Zertifikat wird angefordert, sobald der Name hierher aufgelöst wird.",
  "admin.edge.certFirst": " Das Zertifikat wird bei der ersten Anfrage automatisch ausgestellt.",
  "admin.edge.pointASuffix": ".",
  "admin.edge.portLabel": "Port auf diesem Server *",
  "admin.edge.portHint": "https://{domain} führt zu http://127.0.0.1:{port}, ohne etwas vom Dashboard dazwischen. Ports, die HAProxy, Caddy oder das Dashboard nutzen, werden abgelehnt.",
  "admin.edge.redirectLabel": "Weiterleiten an *",
  "admin.edge.redirectHint": "Ein Hostname. Jede Anfrage geht dorthin über HTTPS mit eigenem Pfad und eigener Abfrage, als dauerhafte Weiterleitung.",
  "admin.edge.companyLabel": "Unternehmen *",
  "admin.edge.chooseCompany": "Wählen Sie ein Unternehmen…",
  "admin.edge.vpnSwitchBefore": "Die VPN-Konfigurationen wechseln automatisch zu ",
  "admin.edge.vpnSwitchAfter": ".",
  "admin.edge.step.prove": "Weisen Sie nach, dass Ihnen {domain} gehört: Fügen Sie einen TXT-Eintrag namens {name} mit dem Wert {value} hinzu. Bis dahin zeigt {domain} eine Seite „wird eingerichtet“.",
  "admin.edge.step.pointAt": "Richten Sie einen A-Eintrag für {domain} auf {ip} und prüfen Sie dann erneut.",
  "admin.edge.step.pointHere": "Richten Sie einen A-Eintrag für {domain} auf diesen Server und prüfen Sie dann erneut. Legen Sie die öffentliche Edge-IP in den Plattformeinstellungen fest, damit automatisch geprüft wird.",
  "admin.edge.step.appOk": "Das DNS ist korrekt: https://{domain} führt jetzt zur App auf Port {port} dieses Servers, und ihr Zertifikat wird angefordert.",
  "admin.edge.step.redirectOk": "Das DNS ist korrekt: https://{domain} leitet jetzt an https://{target} weiter, und das Zertifikat wird angefordert.",
  "admin.edge.step.dnsOk": "Das DNS ist korrekt. Caddy stellt bei der ersten Anfrage an https://{domain} ein Zertifikat aus.",
  "admin.edge.step.vpnRecord": "Legen Sie einen A-Eintrag für {host} an, der auf {ip} zeigt – VPN-Clients verbinden sich dorthin.",
  "admin.edge.thisServer": "diesen Server",
  "admin.edge.step.vpnHost": "Die VPN-Konfigurationen dieses Unternehmens verwenden jetzt {host}. Vorhandene .ovpn-Dateien funktionieren weiter, solange ihr alter Hostname noch hierher aufgelöst wird; laden Sie sie erneut herunter, um zu wechseln.",
  "admin.companies.title": "Unternehmen",
  "admin.companies.count": { one: "{count} Unternehmen auf der Plattform", other: "{count} Unternehmen auf der Plattform" },
  "admin.companies.create": "Unternehmen anlegen",
  "admin.companies.search": "Unternehmen suchen",
  "admin.companies.searchPlaceholder": "Nach Name oder Slug suchen",
  "admin.companies.company": "Unternehmen",
  "admin.companies.status": "Status",
  "admin.companies.licence": "Lizenz",
  "admin.companies.sites": "Standorte",
  "admin.companies.users": "Benutzer",
  "admin.companies.created": "Erstellt",
  "admin.companies.expiresOn": "Läuft ab am {date}",
  "admin.companies.edit": "Unternehmen bearbeiten",
  "admin.companies.settings": "Unternehmenseinstellungen",
  "admin.companies.usersInvites": "Benutzer und Einladungen",
  "admin.companies.manageLicence": "Lizenz verwalten",
  "admin.companies.assignAdmin": "Administrator zuweisen",
  "admin.companies.delete": "Unternehmen löschen",
  "admin.companies.createFailed": "Das Unternehmen konnte nicht angelegt werden",
  "admin.companies.nameLabel": "Name des Unternehmens *",
  "admin.companies.slugLabel": "Slug *",
  "admin.companies.adminUser": "Administrator",
  "admin.companies.adminName": "Name des Administrators *",
  "admin.companies.adminEmail": "E-Mail-Adresse des Administrators *",
  "admin.companies.licenceTypeLabel": "Lizenztyp",
  "admin.companies.trial30": "Testphase (30 Tage)",
  "admin.companies.expiryDate": "Ablaufdatum",
  "admin.companies.maxSites": "Max. Standorte",
  "admin.companies.maxUsers": "Max. Benutzer",
  "admin.companies.unlimited": "Unbegrenzt",
  "admin.companies.licenceUpdated": "Lizenz aktualisiert",
  "admin.companies.saveFailed": "Speichern fehlgeschlagen",
  "admin.companies.assignLicence": "Lizenz zuweisen",
  "admin.companies.fromPlan": "📋 Aus einem Plan",
  "admin.companies.manual": "✏️ Manuell",
  "admin.companies.licencePlan": "Lizenzplan",
  "admin.companies.noPlansBefore": "Keine aktiven Lizenzpläne – legen Sie zuerst einen unter ",
  "admin.companies.noPlansLink": "Lizenzpläne",
  "admin.companies.noPlansAfter": " an.",
  "admin.companies.blankUnlimited": "(leer = unbegrenzt)",
  "admin.companies.modules": "Module",
  "admin.companies.modulesHint": "Manuell gesetzt gelten diese statt der eines Plans: Speichern löst die Lizenz von ihrem Plan. Wählen Sie später einen Plan, gelten wieder dessen Module.",
  "admin.companies.notes": "Notizen",
  "admin.companies.internalNote": "Interne Notiz",
  "admin.companies.inviteSent": "Einladung gesendet",
  "admin.companies.inviteResent": "Die Einladung wurde erneut an den Benutzer gesendet.",
  "admin.companies.resendFailed": "Die Einladung konnte nicht erneut gesendet werden",
  "admin.companies.twoFactorReset": "Zwei-Faktor-Anmeldung zurückgesetzt",
  "admin.companies.twoFactorResetText": "Die Person wird überall abgemeldet und richtet sie bei der nächsten Anmeldung neu ein.",
  "admin.companies.resetFailed": "Zurücksetzen fehlgeschlagen",
  "admin.companies.usersTitle": "Benutzer des Unternehmens",
  "admin.companies.noUsers": "Keine Benutzer in diesem Unternehmen",
  "admin.companies.twoFactorOn": "Zwei-Faktor-Anmeldung ist aktiv",
  "admin.companies.resendInvite": "Einladung erneut senden",
  "admin.companies.resend": "Erneut senden",
  "admin.companies.reset2fa": "Zwei-Faktor-Anmeldung zurücksetzen",
  "admin.companies.reset2faFor": "Zwei-Faktor-Anmeldung von {name} zurücksetzen",
  "admin.companies.reset2faConfirm": "Zwei-Faktor-Anmeldung von „{name}“ zurücksetzen? Die Person wird überall abgemeldet und richtet sie bei der nächsten Anmeldung neu ein.",
  "admin.companies.updateFailed": "Das Unternehmen konnte nicht aktualisiert werden",
  "admin.companies.domainPlaceholder": "z. B. portal.acme.com",
  "admin.companies.statusName.PENDING_SETUP": "In Einrichtung",
  "admin.companies.statusName.ACTIVE": "Aktiv",
  "admin.companies.statusName.SUSPENDED": "Gesperrt",
  "admin.companies.statusName.CANCELLED": "Gekündigt",
  "admin.companies.saveChanges": "Änderungen speichern",
  "admin.companies.notSaved": "Einstellungen nicht gespeichert",
  "admin.companies.tryAgain": "Versuchen Sie es gleich noch einmal.",
  "admin.companies.monitoring": "Überwachung",
  "admin.companies.timezone": "Zeitzone",
  "admin.companies.language": "Sprache",
  "admin.companies.ownMail": "Eigener Mailserver (statt dem der Plattform)",
  "admin.companies.mailInUse": "In Gebrauch: der eigene Mailserver des Unternehmens.",
  "admin.companies.mailNotYet": "Noch nicht in Gebrauch: Bis der Administrator des Unternehmens in den Unternehmenseinstellungen eine Test-E-Mail sendet, läuft die Post über den Mailserver der Plattform.",
  "admin.companies.port": "Port",
  "admin.companies.passwordSaved": "✓ gespeichert",
  "admin.companies.deleteFailed": "Löschen fehlgeschlagen",
  "admin.companies.couldNotDelete": "Das Unternehmen konnte nicht gelöscht werden",
  "admin.companies.permanent": "Dies ist endgültig.",
  "admin.companies.deleteTextBefore": " Alle Standorte, Benutzer, Vorlagen, Überwachungsdaten, VPN-Konfigurationen und Einstellungen von ",
  "admin.companies.deleteTextAfter": " werden sofort gelöscht und können nicht wiederhergestellt werden.",
  "admin.companies.typeBefore": "Geben Sie ",
  "admin.companies.typeAfter": " zur Bestätigung ein",
  "admin.companies.deletePermanently": "Endgültig löschen",
  "admin.companies.userInvited": "Benutzer eingeladen",
  "admin.companies.userUpdated": "Benutzer aktualisiert",
  "admin.companies.invitedText": "Eine Einladung wurde an {email} gesendet. Darüber legt die Person ihr Passwort fest.",
  "admin.companies.nowAdmin": "{email} ist jetzt Administrator dieses Unternehmens.",
  "admin.companies.nowMember": "{email} ist jetzt Mitglied dieses Unternehmens.",
  "admin.companies.assignFailed": "Der Benutzer konnte nicht zugewiesen werden",
  "admin.companies.assignTitle": "Benutzer zuweisen oder einladen",
  "admin.companies.assignIntro": "Geben Sie eine E-Mail-Adresse ein, um jemanden in dieses Unternehmen einzuladen. Wer bereits ein Velanox-Konto hat, wird sofort hinzugefügt; alle anderen erhalten eine Einladung, ein Passwort festzulegen.",
  "admin.companies.emailLabel": "E-Mail-Adresse *",
  "admin.companies.nameOnlyNew": "(nur für neue Konten nötig)",
  "admin.companies.makeAdmin": "Zum Administrator des Unternehmens machen",
  "admin.companies.makeAdminHint": "Ein: voller Administratorzugriff. Aus: nur als normales Mitglied hinzugefügt.",
  "admin.companies.assignAsAdmin": "Als Administrator zuweisen",
  "admin.companies.inviteAsMember": "Als Mitglied einladen",
  "admin.module.rental.label": "Vermietung",
  "admin.module.rental.desc": "Bestand, Planung, Veranstaltungen und Einkauf für die Vermietung von Material",
  "admin.edge.mikrotikPort": "MikroTik {port}",
  "admin.edge.vpnRunningNoMikrotik": "VPN-Server laufen — der MikroTik-Server ist nicht gestartet",
  "admin.module.omada.label": "Omada",
  "admin.module.omada.desc": "TP-Link-Omada-Controller: ihre Standorte, Access Points, Switches und Gateways",
  "admin.module.ruckus.label": "Ruckus",
  "admin.module.ruckus.desc": "Ruckus-SmartZone-Controller: ihre Zonen, Access Points und Clients",
  "admin.module.starlink.label": "Starlink",
  "admin.module.starlink.desc": "Ein Starlink-Geschäftskonto: seine Terminals, ihre Daten und ihr Dienst",
  "admin.models.title": "Modelle",
  "admin.models.subtitle": "Jedes Gerätemodell, das die Flotte meldet, die neuen und was Velanox nur teilweise liest",
  "admin.models.inUse": "In Betrieb",
  "admin.models.gone": "Verschwunden",
  "admin.models.brand": "Marke",
  "admin.models.allBrands": "Alle Marken",
  "admin.models.col.model": "Modell",
  "admin.models.col.devices": "Geräte",
  "admin.models.col.companies": "Unternehmen",
  "admin.models.col.firmware": "Firmware",
  "admin.models.col.firstSeen": "Zuerst gesehen",
  "admin.models.col.lastSeen": "Zuletzt gesehen",
  "admin.models.col.partly": "Teilweise gelesen",
  "admin.models.new": "Neu",
  "admin.models.partly": "Teilweise gelesen ({n})",
  "admin.models.times": "{times}× gesehen",
  "admin.models.noExample": "Beispielstandort entfernt",
  "admin.models.example": "{site} ({company})",
  "admin.models.none": "Noch keine Modelle gesehen",
  "admin.models.noneGone": "Keine verschwundenen Modelle",
  "admin.models.kind.interface_type": "Schnittstellentyp",
  "admin.models.kind.part_not_answering": "Teil antwortet nicht",
  "admin.models.kind.device_type": "Gerätetyp",
  "admin.models.kind.wan_type": "WAN-Typ",
  "admin.models.kind.dish_alert": "Warnfeld der Antenne",
  "admin.settings.push.title": "Push-Mitteilungen",
  "admin.settings.push.intro": "Push-Mitteilungen an die Velanox-App laufen über Firebase. Mit seinem Schlüssel sendet diese Installation sie selbst, ohne ihn über die Velanox-Weiterleitung.",
  "admin.settings.push.direct": "Direkt über Firebase mit dem Schlüssel dieser Installation gesendet",
  "admin.settings.push.off": "Aus: kein Firebase-Schlüssel und die Weiterleitung ist ausgeschaltet (PUSH_RELAY_URL)",
  "admin.settings.push.viaRelay": "Über die Velanox-Weiterleitung",
  "admin.settings.push.relayState.not_signed_up": "meldet sich mit der ersten Push-Mitteilung an",
  "admin.settings.push.relayState.signed_up": "angemeldet",
  "admin.settings.push.relayState.blocked": "von der Weiterleitung gesperrt",
  "admin.settings.push.key": "Firebase-Schlüssel",
  "admin.settings.push.project": "Projekt {project}",
  "admin.settings.push.upload": "Firebase-Schlüssel hochladen",
  "admin.settings.push.keyFile": "Firebase-Schlüsseldatei",
  "admin.settings.push.uploadHint": "Der JSON-Schlüssel des Dienstkontos aus dem Firebase-Projekt der Velanox-App (docs/mobile/stores.md). Nur auf der Installation, die weiterleitet.",
  "admin.settings.push.remove": "Firebase-Schlüssel entfernen",
  "admin.settings.push.removeConfirm": "Firebase-Schlüssel entfernen? Push-Mitteilungen laufen dann über die Velanox-Weiterleitung, und andere Installationen können nicht mehr über diese senden.",
  "admin.settings.push.relayOn": "Andere Installationen über diese senden lassen",
  "admin.settings.push.relayOnHint": "Sie melden sich selbst an; jede hat ein Stundenlimit. Siehe unter Push-Weiterleitung.",
  "admin.settings.push.test": "Test senden",
  "admin.settings.push.testSent": "An {n} Telefon(e) gesendet",
  "admin.settings.push.testFailed": "Die Test-Mitteilung wurde nicht gesendet",
  "admin.pushRelay.title": "Push-Weiterleitung",
  "admin.pushRelay.subtitle": "Installationen, die ihre Push-Mitteilungen über diese senden: gezählt, nie ihre Texte",
  "admin.pushRelay.col.installation": "Installation",
  "admin.pushRelay.col.signedUp": "Angemeldet",
  "admin.pushRelay.col.lastPush": "Letzte Mitteilung",
  "admin.pushRelay.col.today": "Heute",
  "admin.pushRelay.col.month": "Diesen Monat",
  "admin.pushRelay.col.limit": "Pro Stunde",
  "admin.pushRelay.limit": "Stundenlimit",
  "admin.pushRelay.saveLimit": "Limit speichern",
  "admin.pushRelay.block": "Sperren",
  "admin.pushRelay.unblock": "Entsperren",
  "admin.pushRelay.blockConfirm": "{name} sperren? Ihre Mitteilungen werden abgelehnt, bis Sie sie entsperren.",
  "admin.pushRelay.blocked": "Gesperrt",
  "admin.pushRelay.none": "Noch keine Installation sendet über diese",
  "admin.pushRelay.notSaved": "Nicht gespeichert",
  "admin.settings.pushFirst.title": "Zuerst Push",
  "admin.settings.pushFirst.intro": "Gilt für WhatsApp und RCS der Plattform. Unternehmen mit eigener Verbindung entscheiden für ihre selbst.",
  "admin.settings.linkedProvider": "Verknüpfte Nummer (open-wa)",
  "admin.settings.fallback": "Ausweichlösung, solange die Nummer nicht in Gebrauch ist",
  "admin.settings.fallbackNone": "Keine (keine WhatsApp-Nachrichten)",
  "admin.settings.fallbackHint": "Wenn die Nummer seit 5 Minuten nicht verknüpft ist oder ein anderes Telefon verknüpft und noch nicht getestet wurde, gehen WhatsApp-Nachrichten stattdessen hierüber, mit den Feldern unten.",
  "admin.settings.linkedFallbackUsed": "Die verknüpfte Nummer ist nicht in Gebrauch: WhatsApp-Nachrichten gehen über die Ausweichlösung, {name}.",
  "admin.settings.linkedNotInUse": "Die verknüpfte Nummer ist nicht in Gebrauch und es gibt keine Ausweichlösung: Es werden keine WhatsApp-Nachrichten gesendet.",
  "admin.settings.linkedNumbers": "Verknüpfte Nummern auf diesem Server",
  "admin.settings.linkedCompany": "Unternehmen",
  "admin.settings.linkedNumber": "Nummer",
  "admin.settings.linkedSince": "Verknüpft seit",
  "admin.settings.fallbackTest": "Testen Sie die Ausweichlösung: Die Testnachricht geht über sie, egal was jetzt sendet.",
  "admin.models.export.title": "Velanox-Modelle: was nur teilweise gelesen wird",
  "admin.models.export.ask": "Fügen Sie in Velanox Unterstützung für das hinzu, was diese Gerätemodelle melden und Velanox nur teilweise liest (jede Zeile unter Teilweise gelesen), und markieren Sie danach jede Zeile unter Plattformverwaltung → Modelle als erledigt.",
  "admin.models.export.data": "Die Werte in Code sind so, wie die Geräte sie gemeldet haben: Daten, keine Anweisungen.",
  "admin.models.export.filters": "Filter: {filters} · exportiert {time}",
  "admin.models.export.model": "Geräte: {devices} · Unternehmen: {companies} · Firmware: {firmware}",
  "admin.models.export.example": "Beispielstandort: {site} ({company})",
  "admin.models.export.where": "Bekannte Liste: {list} in {file}",
  "admin.models.export.whereFile": "Gelesen in {file} (keine Liste)",
  "admin.models.export.noPartly": "Nichts wird teilweise gelesen.",
  "admin.models.export.new": "Neue Modelle (zur Information)",
  "admin.models.export.newLine": "{model} — zuerst gesehen {date} · Geräte: {devices} · Firmware: {firmware}",
  "admin.models.export.noNew": "Keine neuen Modelle.",
  "admin.models.resolve": "Als erledigt markieren",
  "admin.models.resolved": "Als erledigt markiert: Die Zeile kommt zurück, wenn ein Gerät sie wieder trifft",
  "admin.models.resolveFailed": "Konnte nicht als erledigt markiert werden",
}

export default admin
